module.exports = __webpack_public_path__ + "img/profile.f7a49eae.jpg";